/**
 * Login scope types
 */
export enum LoginScope {
  Platform = 0, // Platform user login
  Team = 1, // Team user login
}

/**
 * Team member role types
 */
export enum TeamRole {
  Invalid = 0, // Invalid type
  Owner = 1, // Team owner/creator
  Admin = 2, // Team administrator
  Normal = 3, // Normal member
}

/**
 * Team quota types (maps to backend Quota_Type)
 */
export enum QuotaType {
  Invalid = 0, // Invalid type
  MeshCount = 1, // UserNetworkVXLAN - Number of VXLAN networks
  MeshEndpointCount = 2, // UserEndpoint - Number of endpoints per mesh network
  InstanceCount = 3, // UserInstance - Number of instances
  SnapshotCount = 4, // UserSnapshot - Number of snapshots
  StorageBytes = 5, // UserVolumeSizeBytes - Storage capacity limit in bytes
  AutoDeployment = 6, // UserAutoDeployment - Number of auto deployments
  AutoScaling = 7, // UserAutoScaling - Number of auto scaling specs
  ImageCount = 8, // UserImage - Number of custom images
  MeshNetCount = 9, // UserMesh - Number of mesh networks
}

/**
 * Team role label mapping for display
 */
export const teamRoleLabel: Record<TeamRole, 'Invalid' | 'Owner' | 'Admin' | 'Member'> = {
  [TeamRole.Invalid]: 'Invalid',
  [TeamRole.Owner]: 'Owner',
  [TeamRole.Admin]: 'Admin',
  [TeamRole.Normal]: 'Member',
}

/**
 * Privilege types for authentication and token management
 */
export const PrivilegeType = {
  // Image management privilege (official role features)
  ImageMgt: 54,

  // Datadrive access
  PersonalBox: 17, // Personal datadrive access (read/write)
  TeamBoxReadOnly: 18, // Team datadrive access (read-only)
  TeamBoxReadWrite: 19, // Team datadrive access (read/write)

  // Image storage
  ImageStore: 56, // Custom image storage access

  // Team/Platform token switching
  TeamToken: 57, // Switch from platform to team
  PlatformToken: 58, // Switch from team to platform (not used in current implementation)

  // CLI token
  CliToken: 66, // CLI token for Datadrive command-line access

  // SDK token (user-facing, generated on profile page; exp 30 days).
  // Optional grant param sdk_token_scope: 1 (default) = all user instances,
  // 2 = restricted to instances created by this sdk-token.
  SdkAccess: 67,

  // Canvas API access (Model Route pages; exp 7 days, no extra grant params)
  CanvasAccess: 68,
} as const

// Optional /auth/grant param for SdkAccess tokens
export const SDK_TOKEN_SCOPE = {
  AllInstances: 1, // token can control all of the user's instances (default)
  Restricted: 2, // token can only control instances it created
} as const

/**
 * Login source storage key
 */
export const LOGIN_SOURCE_KEY = 'glows_login_source'

/**
 * Login source types
 */
export enum LoginSource {
  Platform = 'platform',
  Team = 'team',
}
